import { ApiProperty } from "@nestjs/swagger";

export class PayrollComponentsDto {

    @ApiProperty()
    employeeId: number;

    @ApiProperty()
    basic: number;

    @ApiProperty()
    hraAmount: number;
    
    @ApiProperty()
    eduAmount: number;

    
    @ApiProperty()
    medicalAmount: number;

    
    @ApiProperty()
    splAmount: number;

    
    @ApiProperty()
    conveyanceAmount: number;

    
    @ApiProperty()
    petrolAmount: number;

    
    @ApiProperty()
    shoeAmount: number;

    @ApiProperty()
    washingAmount: number;

    
    @ApiProperty()
    uniformAmount: number;

    @ApiProperty()
    helperAmount: number;

    @ApiProperty()
    productionAmount: number;

    @ApiProperty()
    taAmount: number;

    @ApiProperty()
    bonusAmount: number;

    @ApiProperty()
    messAmount:number

    @ApiProperty()
    othersAmount:number

    @ApiProperty()
    userName: string;

    @ApiProperty()
    employeeName: string;

    @ApiProperty()
    employeeCode: string;

    @ApiProperty()
    employeeType: string;

    @ApiProperty()
    employeeCategory: string;

    @ApiProperty()
    designation :number;

    @ApiProperty()
    department:number;

    @ApiProperty()
    unitId:number


}


// import { ApiProperty } from "@nestjs/swagger";

// export class PayrollComponentsDto {

//     @ApiProperty()
//     employeeId: number;

//     @ApiProperty()
//     basic: number;

//     @ApiProperty()
//     hraAmount: number;
    
//     @ApiProperty()
//     eduAmount: number;

//     @ApiProperty()
//     medicalAmount: number;

//     @ApiProperty()
//     splAmount: number;

//     @ApiProperty()
//     conveyanceAmount: number;

//     @ApiProperty()
//     petrolAmount: number;

//     @ApiProperty()
//     shoeAmount: number;

//     @ApiProperty()
//     washingAmount: number;

//     @ApiProperty()
//     uniformAmount: number;

//     @ApiProperty()
//     helperAmount: number;

//     @ApiProperty()
//     productionAmount: number;

//     @ApiProperty()
//     taAmount: number;

//     @ApiProperty()
//     bonusAmount: number;

//     @ApiProperty()
//     userName: string;

//     constructor(
//         employeeId: number,
//         basic: number,
//         hraAmount: number,
//         eduAmount: number,
//         medicalAmount: number,
//         splAmount: number,
//         conveyanceAmount: number,
//         petrolAmount: number,
//         shoeAmount: number,
//         washingAmount: number,
//         uniformAmount: number,
//         helperAmount: number,
//         productionAmount: number,
//         taAmount: number,
//         bonusAmount: number,
//         userName: string
//     ) {
//         this.employeeId = employeeId;
//         this.basic = basic;
//         this.hraAmount = hraAmount;
//         this.eduAmount = eduAmount;
//         this.medicalAmount = medicalAmount;
//         this.splAmount = splAmount;
//         this.conveyanceAmount = conveyanceAmount;
//         this.petrolAmount = petrolAmount;
//         this.shoeAmount = shoeAmount;
//         this.washingAmount = washingAmount;
//         this.uniformAmount = uniformAmount;
//         this.helperAmount = helperAmount;
//         this.productionAmount = productionAmount;
//         this.taAmount = taAmount;
//         this.bonusAmount = bonusAmount;
//         this.userName = userName;
//     }
// }
